import { ActionBrick, registerBrick, ErrorFlow, File as OFile } from 'olympe';

export default class GetRawFileContent extends ActionBrick {

    /**
     * @protected
     * @param {!BrickContext} context
     * @param {File} file
     * @param {function()} forwardEvent
     * @param {function(ArrayBuffer)} setContent
     */
    async update(context, [file], [forwardEvent, setContent]) {

        if (!(file instanceof OFile)) {
            // warning for legacy usage of the brick, where string/ArrayBuffer was provided as input
            throw ErrorFlow.create('GetRawFileContent:', file, 'is not a valid file', 1);
        }

        setContent(await file.getContentAsBinary());
        forwardEvent();
    }
}

registerBrick('0177fe2096fc87616816', GetRawFileContent);
